// One quiet line about the dedicated scanner, shown only inside the native shell: connected
// scanner and battery, or why none is (no app key, SDK error, nothing paired).

import { useEffect, useState } from "react";
import { t } from "../i18n.js";
import { inShell, scannerStatus, subscribeScanner, type ScannerStatus } from "../scan/native.js";

export function scannerText(s: ScannerStatus | null): { text: string; tone: "ok" | "warn" | "off" } {
  if (!s) return { text: t("scanner.waiting"), tone: "off" };
  if (!s.configured) return { text: t("scanner.noKey"), tone: "warn" };
  if (s.error && !s.opened) return { text: t("scanner.error", { e: s.error }), tone: "warn" };
  const d = s.devices[0];
  if (!d) return { text: t("scanner.none"), tone: "off" };
  return { text: d.battery === null ? t("scanner.connected", { name: d.name }) : t("scanner.connectedBattery", { name: d.name, battery: d.battery }), tone: "ok" };
}

export function ScannerLine() {
  const [s, setS] = useState<ScannerStatus | null>(() => scannerStatus());
  useEffect(() => (inShell() ? subscribeScanner(setS) : undefined), []);
  if (!inShell()) return null;
  const { text, tone } = scannerText(s);
  return (
    <div className={`scanner-line ${tone}`} role="status">
      <span className="dot" />
      {text}
    </div>
  );
}
